
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/amanaki-thao-dien/dinning",
      function () {
        return require("private-next-pages/amanaki-thao-dien/dinning/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/amanaki-thao-dien/dinning"])
      });
    }
  